module.exports = __webpack_public_path__ + "static/media/YF56_2.e342cf08.jpg";